import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
import type { AoisNotification } from './useDownloadNotifications.models';

function useReadAoisNotification() {
  const { propertyId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['read-aois-notification'],
    mutationFn: async (notificationIds: string[]) => {
      notificationIds.forEach((id) => {
        localStorage.setItem(`image_catalog_file_${id}`, 'read');
      });

      queryClient.setQueryData<{
        [key: string]: AoisNotification;
      }>(['aois-notifications', { propertyId }], (oldData) => {
        if (!oldData) return oldData;

        const newData = notificationIds.reduce<{
          [key: string]: AoisNotification;
        }>(
          (acc, cur) => {
            const oldNotification = acc[cur];

            if (oldNotification) {
              acc[cur] = {
                ...oldNotification,
                metadata: { ...oldNotification.metadata, read: true },
              } as AoisNotification;
            }

            return acc;
          },
          { ...oldData }
        );

        return newData;
      });
    },
  });
}

export { useReadAoisNotification };
